module.exports = __webpack_public_path__ + "img/x_large.49cd6bb2.svg";